import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    this.updateTheme()
  }

  toggle() {
    if (localStorage.theme === 'dark') {
      localStorage.theme = 'light'
      document.documentElement.classList.remove('dark')
    } else {
      localStorage.theme = 'dark'
      document.documentElement.classList.add('dark')
    }
    this.updateTheme()
  }

  updateTheme() {
    // Check local storage or system preference
    if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      document.documentElement.classList.add('dark')
      if (this.hasIconTarget) {
        this.iconTarget.classList.remove('fa-moon')
        this.iconTarget.classList.add('fa-sun')
      }
    } else {
      document.documentElement.classList.remove('dark')
      if (this.hasIconTarget) {
        this.iconTarget.classList.remove('fa-sun')
        this.iconTarget.classList.add('fa-moon')
      }
    }
  }
}
